import { formatISODate } from "@clipboard-health/date-time";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { PACIFIC_TIME_ZONE } from "@src/appV2/Timezone/constants";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { zonedTimeToUtc } from "date-fns-tz";

export function useFormatTimestampForWorkplace() {
  const session = useSession();
  const sessionTimezone = session.profile?.tmz ?? PACIFIC_TIME_ZONE;
  return (timestamp: Date) => zonedTimeToUtc(timestamp, sessionTimezone).toISOString();
}

/**
 * Reverse of {@link useFormatTimestampForWorkplace}: converts a stored ISO
 * timestamp into a `yyyy-MM-dd` string in the workplace timezone, suitable for
 * pre-filling a native `<input type="date">`.
 */
export function useFormatWorkplaceDateInput() {
  const session = useSession();
  const sessionTimezone = session.profile?.tmz ?? PACIFIC_TIME_ZONE;
  return (timestamp: string) => formatISODate(timestamp, { timeZone: sessionTimezone });
}
